module.exports = __webpack_public_path__ + "img/video-conference-dark.8c3a3a41.svg";